


















































import Vue from "vue";
import _ from "lodash";

import { RootState } from "@/store";
import { mapState } from "vuex";

// Model
import { getLicenseModuleLabel, defaultLicenseModuleEnumSorting } from "@/model/data/License/LicenseModuleEnum";
import { getLicenseModuleIconColor } from "@/utility/Constants";
import VFaIcon from "@/components/VFaIcon.vue";

export default Vue.extend({
    components: { VFaIcon },
    data() {
        return {
            headers: [
                {
                    value: "module",
                    text: this.$t("licensesManagement.module"),
                    sortable: false,
                    width: "30%",
                },
                {
                    value: "totalLicenses",
                    text: this.$t("licensesManagement.totalLicenses"),
                    align: "center",
                    sortable: false,
                },
                {
                    value: "assignedLicenses",
                    text: this.$t("licensesManagement.assignedLicenses"),
                    align: "center",
                    sortable: false,
                },
                {
                    value: "availableLicenses",
                    text: this.$t("licensesManagement.availableLicenses"),
                    align: "center",
                    sortable: false,
                },
                {
                    value: "actions",
                    text: "",
                    align: "center",
                    sortable: false,
                },
            ],
        };
    },
    props: {
        loading: {
            required: true,
            type: Boolean,
        },
        isSaveButtonEnable: {
            required: true,
            type: Boolean,
        },
    },
    computed: {
        ...mapState({
            // licensesDataSummary: (state: RootState) => state.license.licensesDataSummary,
            licensesDataSummary: (state: RootState) => state.license.licensesDataSummaryLocal,
            localInstallations: (state: RootState) => state.license.localInstallations,
        }),

        items() {
            let arrayResult = [];

            this.defaultLicenseModuleEnumSorting().forEach((moduleEnumValue) => {
                if (
                    this.licensesDataSummary.filter((c) => c.module == moduleEnumValue).length > 0 &&
                    this.licensesDataSummary.filter((c) => c.module == moduleEnumValue)[0].totalLicenses > 0
                )
                    arrayResult.push(this.licensesDataSummary.filter((c) => c.module == moduleEnumValue)[0]);
            });

            return arrayResult;
        },
    },
    methods: {
        getLicenseModuleLabel,
        getLicenseModuleIconColor,
        defaultLicenseModuleEnumSorting,
    },
});
